// Pure, immutable helpers for optimistic updates on the comment tree. Recursion
// keeps them correct for both top-level comments and nested replies.
export const removeCommentFromTree = (nodes, id) => nodes
  .filter(node => node.id !== id)
  .map(node => ({ ...node, replies: removeCommentFromTree(node.replies, id) }))

export const addReplyToTree = (nodes, parentId, reply) => nodes.map(node => (
  node.id === parentId
    ? { ...node, replies: [...node.replies, reply] }
    : { ...node, replies: addReplyToTree(node.replies, parentId, reply) }
))

// Swaps a pending node for the persisted one the create response returned, in
// place - so the node keeps its position and its existing replies survive.
export const replaceCommentInTree = (nodes, id, replacement) => nodes.map(node => (
  node.id === id
    ? { ...replacement, replies: node.replies }
    : { ...node, replies: replaceCommentInTree(node.replies, id, replacement) }
))
